(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCarousel(section) {
      var grid = section.querySelector('[data-about-carousel]');
      if (!grid) return;

      var origCards = Array.from(grid.querySelectorAll('.about-card:not([data-clone])'));
      var count = origCards.length;
      if (count < 2) return;

      var current = 0;
      var isSetup = false;
      var startX = 0;
      var startY = 0;
      var dragDeltaX = 0;
      var isDragging = false;
      var SWIPE_THRESHOLD = 40;

      function allCards() {
        return Array.from(grid.querySelectorAll('.about-card'));
      }

      function getOffset(index) {
        var cards = allCards();
        var card = cards[index];
        if (!card) return 0;
        var wrapperWidth = grid.parentElement.offsetWidth;
        var cardWidth = card.offsetWidth;
        // Center the card within the wrapper
        return -(card.offsetLeft - (wrapperWidth - cardWidth) / 2);
      }

      function setPosition(index, animate) {
        var offset = getOffset(index);
        grid.style.transition = animate
          ? 'transform 0.38s cubic-bezier(0.25, 1, 0.5, 1)'
          : 'none';
        grid.style.transform = 'translateX(' + offset + 'px)';
      }

      function setActive(index) {
        allCards().forEach(function(c, i) {
          c.classList.toggle('about-card--carousel-active', i === index);
        });
      }

      function goTo(index, animate) {
        current = index;
        setPosition(index, animate !== false);
        setActive(index);
      }

      function setup() {
        if (isSetup) return;
        isSetup = true;

        // Prepend clone of last card, append clone of first card
        var cloneLast = origCards[count - 1].cloneNode(true);
        var cloneFirst = origCards[0].cloneNode(true);
        cloneLast.setAttribute('data-clone', 'true');
        cloneFirst.setAttribute('data-clone', 'true');
        grid.prepend(cloneLast);
        grid.appendChild(cloneFirst);

        // Start on first real card (index 1 after prepend)
        current = 1;
        setPosition(current, false);
        setActive(current);

        grid.style.touchAction = 'pan-y';

        grid.addEventListener('touchstart', onTouchStart, { passive: true });
        grid.addEventListener('touchmove', onTouchMove, { passive: true });
        grid.addEventListener('touchend', onTouchEnd, { passive: false });
        grid.addEventListener('transitionend', onTransitionEnd);
      }

      function teardown() {
        if (!isSetup) return;
        isSetup = false;
        grid.querySelectorAll('[data-clone]').forEach(function(el) { el.remove(); });
        grid.style.transform = '';
        grid.style.transition = '';
        grid.style.touchAction = '';
        origCards.forEach(function(c) {
          c.classList.remove('about-card--carousel-active');
        });
        grid.removeEventListener('touchstart', onTouchStart);
        grid.removeEventListener('touchmove', onTouchMove);
        grid.removeEventListener('touchend', onTouchEnd);
        grid.removeEventListener('transitionend', onTransitionEnd);
      }

      function onTouchStart(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dragDeltaX = 0;
        isDragging = true;
      }

      function onTouchMove(e) {
        if (!isDragging) return;
        dragDeltaX = e.touches[0].clientX - startX;
      }

      function onTouchEnd(e) {
        if (!isDragging) return;
        isDragging = false;

        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;

        // Ignore if vertical swipe is dominant
        if (Math.abs(dy) > Math.abs(dx)) return;
        if (Math.abs(dx) < SWIPE_THRESHOLD) return;

        if (dx < 0) {
          goTo(current + 1, true);
        } else {
          goTo(current - 1, true);
        }
      }

      function onTransitionEnd() {
        var cards = allCards();
        var total = cards.length;
        // Seamlessly wrap: clone positions → real positions
        if (current <= 0) {
          current = total - 2;
          setPosition(current, false);
          setActive(current);
        } else if (current >= total - 1) {
          current = 1;
          setPosition(current, false);
          setActive(current);
        }
      }

      function onResize() {
        if (window.innerWidth < 750) {
          if (!isSetup) setup();
          else setPosition(current, false); // recalculate offset on resize
        } else {
          teardown();
        }
      }

      if (window.innerWidth < 750) setup();
      window.addEventListener('resize', onResize);
    }

    document.querySelectorAll('.about-cards').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-catering"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.bb-catering').forEach(function(section) {
      var useCases = section.querySelectorAll('.bb-catering__use-case');
      var formWrap = section.querySelector('[data-bb-catering-form]');
      var cateringInput = section.querySelector('[data-bb-catering-input]');
      var selectedLabel = section.querySelector('[data-bb-catering-label]');
      var placeholder = section.querySelector('[data-bb-catering-placeholder]');

      useCases.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var useCase = btn.getAttribute('data-use-case');
          var isDesktop = window.innerWidth >= 990;

          useCases.forEach(function(b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');

          if (cateringInput) cateringInput.value = useCase;
          if (selectedLabel) selectedLabel.textContent = '→ ' + useCase;

          if (formWrap) {
            formWrap.classList.add('bb-catering__form-wrap--open');
            formWrap.removeAttribute('aria-hidden');

            if (placeholder) {
              placeholder.classList.add('bb-catering__form-placeholder--hidden');
            }

            if (!isDesktop) {
              setTimeout(function() {
                formWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }, 100);
            }
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-brand-controls]').forEach(function(controls) {
    var slider = controls.closest('.brand-hero__slider');
    var video = slider && slider.querySelector('.brand-hero__video');
    if (!video) return;

    var playBtn = controls.querySelector('[data-brand-play]');
    var muteBtn = controls.querySelector('[data-brand-mute]');
    var playIcon = controls.querySelector('[data-brand-play-icon]');
    var pauseIcon = controls.querySelector('[data-brand-pause-icon]');
    var mutedIcon = controls.querySelector('[data-brand-muted-icon]');
    var unmutedIcon = controls.querySelector('[data-brand-unmuted-icon]');

    // Force autoplay
    video.play().catch(function() {});

    function updatePlayUI() {
      if (video.paused) {
        playIcon.style.display = '';
        pauseIcon.style.display = 'none';
      } else {
        playIcon.style.display = 'none';
        pauseIcon.style.display = '';
      }
    }

    function updateMuteUI() {
      if (video.muted) {
        mutedIcon.style.display = '';
        unmutedIcon.style.display = 'none';
      } else {
        mutedIcon.style.display = 'none';
        unmutedIcon.style.display = '';
      }
    }

    updatePlayUI();
    updateMuteUI();

    playBtn.addEventListener('click', function() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      updatePlayUI();
    });

    muteBtn.addEventListener('click', function() {
      video.muted = !video.muted;
      updateMuteUI();
    });

    video.addEventListener('play', updatePlayUI);
    video.addEventListener('pause', updatePlayUI);

    // Fullscreen button
    var fsWrap = slider.querySelector('[data-brand-fullscreen-wrap]');
    var fsBtn = fsWrap && fsWrap.querySelector('[data-brand-fullscreen]');
    if (fsBtn) {
      fsBtn.addEventListener('click', function() {
        if (video.requestFullscreen) video.requestFullscreen();
        else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
        else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["butter-contact"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.bb-contact').forEach(function(section) {
      var topics = section.querySelectorAll('.bb-contact__topic');
      var formWrap = section.querySelector('[data-bb-form-wrap]');
      var topicInput = section.querySelector('[data-bb-topic-input]');
      var selectedLabel = section.querySelector('[data-bb-selected-label]');
      var placeholder = section.querySelector('[data-bb-placeholder]');

      topics.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var topic = btn.getAttribute('data-topic');
          var isDesktop = window.innerWidth >= 990;

          // Deselect all
          topics.forEach(function(b) {
            b.setAttribute('aria-pressed', 'false');
          });

          // Select this one
          btn.setAttribute('aria-pressed', 'true');

          // Populate hidden input
          if (topicInput) topicInput.value = topic;

          // Update label
          if (selectedLabel) {
            selectedLabel.textContent = '→ ' + topic;
          }

          // Reveal form
          if (formWrap) {
            formWrap.classList.add('bb-contact__form-wrap--open');
            formWrap.removeAttribute('aria-hidden');

            // Hide placeholder on desktop
            if (placeholder) {
              placeholder.classList.add('bb-contact__form-placeholder--hidden');
            }

            // Only scroll on mobile (desktop has sticky right col)
            if (!isDesktop) {
              setTimeout(function() {
                formWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }, 100);
            }
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-menu"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-floating-canvas]').forEach(function(canvas) {
    var activeItem = null;
    var startX = 0;
    var startY = 0;
    var clone = null;

    function getPos(e) {
      var t = e.touches ? e.touches[0] : e;
      return { x: t.clientX, y: t.clientY };
    }

    function onStart(e) {
      var item = e.target.closest('[data-floating-item]');
      if (!item) return;
      e.preventDefault();
      activeItem = item;
      var pos = getPos(e);
      startX = pos.x;
      startY = pos.y;

      // Clone only the image
      var img = item.querySelector('.floating-menu__item-image');
      clone = document.createElement('div');
      clone.classList.add('floating-menu__item', 'is-dragging');
      clone.innerHTML = '<div class="floating-menu__item-inner">' + img.outerHTML + '</div>';
      clone.style.left = pos.x + 'px';
      clone.style.top = pos.y + 'px';
      clone.style.transform = 'translate(-50%, -50%)';
      clone.style.setProperty('--item-size', getComputedStyle(item).getPropertyValue('--item-size'));
      document.body.appendChild(clone);

      activeItem.style.opacity = '0.3';
      canvas.classList.add('is-active');
    }

    function onMove(e) {
      if (!clone) return;
      e.preventDefault();
      var pos = getPos(e);
      clone.style.left = pos.x + 'px';
      clone.style.top = pos.y + 'px';
    }

    function onEnd(e) {
      if (!clone) return;
      if (activeItem) activeItem.style.opacity = '';
      canvas.classList.remove('is-active');
      clone.remove();
      clone = null;
      activeItem = null;
    }

    canvas.addEventListener('mousedown', onStart);
    canvas.addEventListener('touchstart', onStart, { passive: false });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchend', onEnd);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-controls]').forEach(function(controls) {
    var container = controls.closest('.hero__media-grid');
    if (!container) return;

    // Target whichever video is currently visible
    function getActiveVideo() {
      var videos = container.querySelectorAll('video');
      for (var i = 0; i < videos.length; i++) {
        var v = videos[i];
        if (v.offsetParent !== null) return v;
      }
      return videos[0] || null;
    }

    var playBtn = controls.querySelector('[data-hero-play]');
    var muteBtn = controls.querySelector('[data-hero-mute]');
    var playIcon = controls.querySelector('[data-hero-play-icon]');
    var pauseIcon = controls.querySelector('[data-hero-pause-icon]');
    var mutedIcon = controls.querySelector('[data-hero-muted-icon]');
    var unmutedIcon = controls.querySelector('[data-hero-unmuted-icon]');

    function updatePlayUI() {
      var video = getActiveVideo();
      if (!video) return;
      playIcon.style.display = video.paused ? '' : 'none';
      pauseIcon.style.display = video.paused ? 'none' : '';
    }

    function updateMuteUI() {
      var video = getActiveVideo();
      if (!video) return;
      mutedIcon.style.display = video.muted ? '' : 'none';
      unmutedIcon.style.display = video.muted ? 'none' : '';
    }

    // Force autoplay and init UI once videos are ready
    container.querySelectorAll('video').forEach(function(v) {
      v.play().catch(function() {});
      v.addEventListener('play', updatePlayUI);
      v.addEventListener('pause', updatePlayUI);
    });

    updatePlayUI();
    updateMuteUI();

    playBtn.addEventListener('click', function() {
      var video = getActiveVideo();
      if (!video) return;
      if (video.paused) { video.play(); } else { video.pause(); }
      updatePlayUI();
    });

    muteBtn.addEventListener('click', function() {
      var muted = !getActiveVideo()?.muted;
      container.querySelectorAll('video').forEach(function(v) { v.muted = muted; });
      updateMuteUI();
    });

    // Fullscreen button
    var fsWrap = controls.closest('.hero__media-grid').querySelector('[data-hero-fullscreen-wrap]');
    var fsBtn = fsWrap && fsWrap.querySelector('[data-hero-fullscreen]');
    if (fsBtn) {
      fsBtn.addEventListener('click', function() {
        var video = getActiveVideo();
        if (!video) return;
        if (video.requestFullscreen) video.requestFullscreen();
        else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
        else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-loc-slider]').forEach(function(slider) {
    var track = slider.querySelector('[data-loc-track]');
    var dots = slider.querySelectorAll('[data-loc-dot]');
    var slides = track.children.length;
    var current = 0;
    var startX = 0;
    var diffX = 0;

    function updateDots() {
      dots.forEach(function(dot, idx) {
        dot.classList.toggle('loc-hero__dot--active', idx === current);
      });
    }

    function goTo(i) {
      current = Math.max(0, Math.min(i, slides - 1));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      updateDots();
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(dot.getAttribute('data-loc-dot'), 10));
      });
    });

    track.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      diffX = e.touches[0].clientX - startX;
    }, { passive: true });

    track.addEventListener('touchend', function() {
      if (Math.abs(diffX) > 50) {
        if (diffX < 0) goTo(current + 1);
        else goTo(current - 1);
      }
      diffX = 0;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-cards-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-menu-filters]').forEach(function(filters) {
    var section = filters.closest('.shopify-section');
    var grid = section && section.querySelector('[data-menu-grid]');
    if (!grid) return;
    var buttons = filters.querySelectorAll('[data-filter]');
    var cards = grid.querySelectorAll('[data-tags]');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        buttons.forEach(function(b) { b.classList.remove('menu-cards__filter--active'); });
        btn.classList.add('menu-cards__filter--active');
        var filter = btn.getAttribute('data-filter');
        cards.forEach(function(card) {
          var cardTags = card.getAttribute('data-tags').split(' ');
          if (filter === 'all' || cardTags.indexOf(filter) !== -1) {
            card.classList.remove('menu-cards__card--hidden');
          } else {
            card.classList.add('menu-cards__card--hidden');
          }
        });
      });
    });
  });

  document.querySelectorAll('.menu-cards__video').forEach(function(v) {
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.play().catch(function() {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-cards-v3"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-menu-filters]').forEach(function(filters) {
    var section = filters.closest('.shopify-section');
    var grid = section && section.querySelector('[data-menu-grid]');
    if (!grid) return;
    var buttons = filters.querySelectorAll('[data-filter]');
    var cards = grid.querySelectorAll('[data-tags]');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        buttons.forEach(function(b) { b.classList.remove('menu-cards__filter--active'); });
        btn.classList.add('menu-cards__filter--active');
        var filter = btn.getAttribute('data-filter');
        cards.forEach(function(card) {
          var cardTags = card.getAttribute('data-tags').split(' ');
          if (filter === 'all' || cardTags.indexOf(filter) !== -1) {
            card.classList.remove('menu-cards__card--hidden');
          } else {
            card.classList.add('menu-cards__card--hidden');
          }
        });
      });
    });
  });

  document.querySelectorAll('.menu-cards__video').forEach(function(v) {
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.play().catch(function() {});
  });

  } catch(e) { console.error(e); }
})();
})();
